module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style-2",
    attrs: {
      "id": "hrye01"
    }
  }, [_c('p', {
    staticClass: "chapter-number",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-head",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-11"
  }, [_vm._v("Prologue: A Bit of Background")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("There has to be a starting point and this one is as good as any: During battle soldiers and warriors have always screamed, shouted, hollered and yelled! There are examples of this throughout recorded history, and no doubt in pre-history as well.—Certainly cavemen, whether Neanderthal or Cro-Magnon, must have hollered their guts out as they swung clubs and threw spears at the enemy, as well as at available meat sources. (We can only hope that these two targets didn’t coincide with one another too often!)—In some instances this activity was undoubtedly planned as part of an army’s overall battle strategy. But it occurred just as often, if not more so, due to the pure adrenaline rush of battle.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("Whether it was intentionally planned strategy or an instinctual, gut-level phenomenon, the battle cry had two primary purposes: First, was to unnerve and frighten the enemy, making their response to attack less effective and possibly causing retreat. Second, was to keep that valuable, and much needed, adrenaline pumping in order to help the attacking force overcome its own fear of battle.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("Through the years the forms that this shouting has taken have varied dramatically. There have been highly formalized cheers—often accompanied by martial music in some form. Think here of the British regulars entering battle in the late Eighteenth and early Nineteenth Centuries while in formation with drums beating cadence and unit “huzzahs” filling the air. On the other end of the spectrum would be the war cry of the African tribesman or the war whoop of the Native American warrior; certainly less formalized, but no less effective—possibly more so! Of course, there is a wide spectrum between these two extremes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("As a general statement it can be said that during the American Civil War the Federal troops more closely followed the British example, while the Confederate Army’s yell was much more akin to the “savage” screams of the various native tribes. In truth, both fall somewhere in between on the overall spectrum.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("The Rebel Yell was renowned throughout the world even before the War was over, when it slipped into the realm of historical legend. Its uniqueness and its demoralizing effect, which is said to have caused enemy soldiers to flee merely upon hearing it, were the basis for this fame.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("Because of its popularity Confederate troops worked at becoming a “good yelling unit” or maybe the “best yelling regiment,” or achieving some other acclaim for their ability to deliver the Yell.—Their reward for this skill was often an assignment to be deployed as advance forces at the beginning of a battle in order that the Rebel Yell could do its damage, including giving the Federals the impression of the Southerners having a much larger force than they actually possessed (see chapter 15). This was particularly true during the first year or so of the Civil War when the South was heavily outnumbered, outgunned and out supplied, unlike later years, when these problems rose to outrageously ludicrous proportions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("The Rebel Yell, while primarily employed during charges or in celebration following a victory, had other uses as well. It was passed along the columns while on the march and passed around from unit to unit in camp. This was similar to “the wave” being passed around a modern sports stadium and had the same basic purpose—to lift morale and inspire enthusiasm. It was even said to be used as a wake-up call in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("Is it any wonder that the Rebel Yell has been called “as much a part of a Rebel’s fighting equipment as his musket”?")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("In order not to over simplify our search for the Rebel Yell—after all, where’s the fun in that?—we now need to dig a little deeper, and in more detail, into some British and American history. Trust me…it’s necessary!")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v("Other than the institution of slavery, the Celtic people who emigrated from the British Isles were the single greatest influence on the culture of the South by the time of the Civil War. This theory of Southern folkways has been expounded most regularly by professor and author, Grady McWhiney")]), _c('span', {
    staticClass: "no-style-override-9"
  }, [_vm._v(", in numerous books and articles. It is a theory I advocate, and which plays a prominent role in our subject, because this Southern-Celtic culture was also the incubator for what became the Rebel Yell. So, it’s important to understand their history—where they came from, their lifestyle and politics, what they had to endure through the years, why they came to America and what they did when they got here. The largest and most influential of these Celtic groups were the Scots-Irish, so we’ll begin with them.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198a096d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/01.vue
// module id = 84
// module chunks = 0